import {getNodeContent} from "@/views/dataEmployeesDes/utils/NodeContentUtils";
import {getUrlParams, GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {openUrl} from "xmgoing-utils";
import {loadDesInfosByCodeSev} from "@/api/domainApi/domainComApi";

/**
 * 打开应用界面设计
 * @param props
 * @param state
 * @param stateRemarks
 */
export const openAppDesPage=function ({props,state,stateRemarks}){
  loadDesInfosByCodeSev(unref(props).pageCode,(datas)=>{
    if(datas.infoSettingJson){
      const params: any = {};
      params.setTotalLoginDes = true;//设置门户的标识
      params["sessionId"] = StorageUtils.getSessionItem("sessionId");
      params["projectI18n"] = StorageUtils.getItem('projectI18n');
      params["pageCode"] = unref(props).pageCode;
      params["appId"] = getUrlParams("appId",true)||StorageUtils.getSessionItem("appId");
      params["mainTableId"] = datas.mainTableId;
      params["pageName"] = datas.pageName;
      params["moduleCode"] = unref(props).moduleCode;
      params["desType"] = "userPageDev";
      params["singleDes"] = "true";
      params["curPageId"] = datas.id;

      //将本界面的全局变量和描述传递给子界面
      const stateJson=JSON.stringify(unref(state));
      const stateRemarksStr=JSON.stringify(unref(stateRemarks));
      StorageUtils.addSessionItem("stateJson",stateJson);
      StorageUtils.addSessionItem("stateRemarksStr",stateRemarksStr);
      nextTick(()=>{
        const vueDesUrl = getUrlParams("vueDesUrl", true);
        window.open(openUrl(`${vueDesUrl||SysConfigUtils.vueDesUrl()}#/formPageDes`, params));
      })
    }
  });

}
/**
 * 获取参数内容格式
 * @param paramValType
 * @param paramVal
 */
export function getParamsStr({paramValType, paramVal,varSubParam=null}) {
  switch (paramValType) {
    case "field"://字段
      return `viewModel.field['${paramVal}']`
      break;
    case "loopObj"://字段
      return `viewModel['${paramVal}']${varSubParam?`['${varSubParam}']`:``}`
      break;
    case "loopVal"://循环节点类型
      if(paramVal==='loopValue'){
        return `viewModel['loopValue']${varSubParam?`['${varSubParam}']`:``}`
        break;
      }else{
        return `viewModel['index']${varSubParam?`['${varSubParam}']`:``}`
        break;
      }
    case "constant"://常量
      if(paramVal==='strEmpty'){
        return `''`
      }
      return `viewModel.constant['${paramVal}']`
      break;
    case "params"://参数
      return `viewModel.params['${paramVal}']`
      break;
    case "systemParams"://系统变量
      return `viewModel.systemParams['${paramVal}']`
      break;
    case "vuexParams"://全局状态变量
      if(varSubParam){
        return `viewModel.getVuexParams('${paramVal}')['${varSubParam}']`
      }else{
        return `viewModel.getVuexParams('${paramVal}')`
      }
    case "vuexState"://全局状态变量
      return `'${paramVal}'`
      break;
    case "aclField"://权限标签
      return `'systemAclField.${paramVal}'`
      break;
    case "userDef"://自定义
      return `\'${paramVal}\'`
      break;
    case "inParams"://入口参数
      return varSubParam?`inParams['${paramVal}']['${varSubParam}']`:`inParams['${paramVal}']`;
      break;
    case "nodeParams"://节点参数
      return varSubParam?`viewModel.nodeParams['${paramVal}']['${varSubParam}']`:`viewModel.nodeParams['${paramVal}']`;
      break;
    case "object"://对象
      return paramVal
      break;
    case "boolean"://布尔
      return GoingNewUtils.parseBoolean(`${paramVal}`)
      break;
    case "number"://数字
      return paramVal
      break;
    default:
      return paramVal
  }
}
export function getHasOutParams(appNodeList,list){
  if(appNodeList&&Array.isArray(appNodeList)){
    appNodeList.forEach((itemDb)=>{
      if(itemDb.outParams&&itemDb.outParams.code){
        list.push(itemDb);
      }
      if(itemDb&&itemDb.children){
        getHasOutParams(itemDb.children,list)
      }
    })
  }
}

/**
 * 获取循环列表
 * @param appNodeList
 * @param list
 */
export function getLoopList(appNodeList,list){
  if(appNodeList&&Array.isArray(appNodeList)){
    appNodeList.forEach((itemDb)=>{
      if(itemDb.nodeType&&itemDb.nodeType==='execution-node-loop'){
        list.push(itemDb);
      }
      if(itemDb&&itemDb.children){
        getLoopList(itemDb.children,list)
      }
    })
  }
}


/**
 * 获取参数根据参数类型
 * @param pDefItem
 * @param paramsDef
 */
export function getParamsByType(pDefItem, paramsDef) {
  const {valueType, filterValue} = pDefItem;
  if(pDefItem["paraName"]){
    paramsDef.push(`${pDefItem["paraName"]}:${getParamsStr({paramValType: valueType, paramVal: filterValue})},`);
  }else{
    paramsDef.push(`${pDefItem["propName"]}:${getParamsStr({paramValType: valueType, paramVal: filterValue})},`);
  }
}

/**
 * 获取最终的内容 根据配置信息
 * @param condtionItem
 */
export function getParamStr(condtionItem) {
  const retAry: Array<String> = [];
  const {condition, paramValType, paramVal, valueType, filterValue,filterSubValue,paramSubVal} = condtionItem;
  const varParam = getParamsStr({paramValType:valueType, paramVal:filterValue,varSubParam:filterSubValue});
  const relValue=getParamsStr({paramValType, paramVal});
  let conSer = "";
  switch (condition) {
    case "isNotEmpty":
      conSer = `(!${varParam}&&${varParam}!=null&&${varParam}!=='')`;
      break;
    case "empty":
      conSer = `(!${varParam}||${varParam}==null||${varParam}==='')`;
      break;
    case "lenBig":
      conSer = `${varParam}.length>${relValue}`;
      break;
    case "lenSmall":
      conSer = `${varParam}.length<${relValue}`;
      break;
    case "lenNotEquals":
      conSer = `${varParam}.length!==${relValue}`;
      break;
    case "lenEquals":
      conSer = `${varParam}.length===${relValue}`;
      break;
    case "str===":
      if (paramVal !== 'strEmpty') {
        conSer = `((${varParam}+'')!=='undefined'&&(${varParam}+'')===${relValue})`;
      } else {
        conSer = `(${varParam}+'')===${relValue}`;
      }
      break;
    case "===":
      conSer = `${varParam}===${relValue}`;
      break;
    case "==":
      conSer = `${varParam}==${relValue}`;
      break;
    case "str!==":
      conSer = `((${varParam}+'')!=='undefined'&&(${varParam}+'')!==${relValue})`;
      break;
    case "startWith":
      conSer = `${varParam}.startsWith(${relValue})`;
      break;
    case "startNot":
      conSer = `!${varParam}.startsWith(${relValue})`;
      break;
    case "endWidth":
      conSer = `${varParam}.endsWith(${relValue})`;
      break;
    case "endNot":
      conSer = `!${varParam}.endsWith(${relValue})`;
      break;
    case "like":
      conSer = `${varParam}.indexOf(${relValue})>=0`;
      break;
    case "notLike":
      conSer = `${varParam}.indexOf(${relValue})<0`;
      break;
    default:
      conSer = `${varParam}${condition}${relValue}`;
  }
  retAry.push(conSer);
  return retAry.join("");
}

/**
 * 获取每个单独的并且集合 构成的内容
 * @param condtionItems
 */
function getConditionStr(condtionItems) {
  //并且相关的结合
  const andAry: Array<String> = [];
  if (condtionItems && condtionItems.length > 0) {
    condtionItems.forEach((condtionItem) => {
      andAry.push(getParamStr(condtionItem));
    })
  }
  return andAry.join("&&");
}

/**
 * 获取else节点的内容信息
 * @param jsAry
 * @param nodeItem
 */
function getElseNodeContent(jsAry, nodeItem,recordItem) {
  jsAry.push("\t else{ \n");
  const {children} = nodeItem;
  if (children) {
    children.forEach((sonNode) => {
      getNodeContent(jsAry, sonNode,recordItem)
    })
  }
  jsAry.push("\t }\n")
}

/**
 * 表单校验
 * @param jsAry
 * @param nodeItem
 * @param recordItem
 */
export function getValidateFormNodeContent(jsAry, nodeItem, recordItem) {

  if (unref(nodeItem).conditionType === 'controlElseNode') {
    getElseNodeContent(jsAry, nodeItem, recordItem);
  } else {
    const {children, msg} = nodeItem;
    function getExeStr() {
      const newAry = [];
      if (children) {
        children.forEach((sonNode) => {
          getNodeContent(newAry, sonNode, recordItem)
        })
      }
      return newAry.join("\n");
    }
    const {validateTarget,validateValueType,validateValueParam,validateValueSubParam,validateNumberType,validateValue}=nodeItem;
    //校验编辑表格（单行）
    if (nodeItem.valiEditorGrid) {
      const {propName, varParam, varParamType, merge, varSubParam} = nodeItem;
      const paramsDef = getParamsStr({paramValType: varParamType, paramVal: varParam, varSubParam});
      jsAry.push(`
           viewModel.validateGrid('${nodeItem.selKey}',${paramsDef},async ()=>{
              ${getExeStr()}
           },()=>{})
     `);
    } else if (validateTarget === 'xmGridObj') {
      const onlySelected = GoingNewUtils.parseBoolean(nodeItem.validateSelectedOnly);
      jsAry.push(`
           viewModel.validateTable('${nodeItem.selKey}',async ()=>{
              ${getExeStr()}
           },()=>{},${onlySelected ? 'true' : 'false'})
     `);
    } else {
      if(validateTarget==='vuexObj'){
        const {validateType}=nodeItem;
        const okFunStr=`${getExeStr()}`;let okEndFlag=false;
        if(okFunStr.indexOf("return void(0)")>0){
          okEndFlag=true;
        }
        const executeStr=`
          const executeFlag = viewModel.validateVuexObj({validateType:'${validateType}',validateOrginVal:${getParamsStr({varSubParam:validateValueSubParam,paramValType: validateValueType, paramVal: validateValueParam})}
           ,validateNumberType:'${validateNumberType}',validateTargetValue:'${validateValue}'},async ()=>{
            ${okFunStr}
           },()=>{})
     `
        //校验表单
        okEndFlag?jsAry.push(`${executeStr};\n if(executeFlag==='ok'){\n return void(0) \n} \n`):jsAry.push(`${executeStr}`);
      }else{
        //校验表单
        jsAry.push(`
           viewModel.validateForm('${nodeItem.selKey}',async ()=>{
            ${getExeStr()}
           },()=>{})
     `);
      }

    }
  }
}

export  function getExeStr(children,recordItem){
  const newAry=[];
  if (children&&Array.isArray(children)) {
    children.forEach((sonNode) => {
      getNodeContent(newAry, sonNode, recordItem)
    })
  }
  return newAry.join("\n");
}
/**
 * 获取确定节点的内容
 * @param jsAry
 * @param nodeItem
 * @param recordItem
 */
export function getConfirmNodeContent(jsAry, nodeItem, recordItem){
  if (unref(nodeItem).conditionType === 'controlElseNode') {
    getElseNodeContent(jsAry, nodeItem,recordItem);
  } else {
    const {children,msg} = nodeItem;
    jsAry.push(`
     GoingUtils.executeConfirm({
          content: '${msg}',
          backFun:async () => {
            ${getExeStr(children,recordItem)}
          }
        })
     `);
  }
}

const getConditionAryStr=function (conditions){
  const jsAry:any=[];
  const conAry: Array<String> = [];
  if (conditions && conditions.length > 0) {
    conditions.forEach((condtionItem) => {
      conAry.push(getConditionStr(condtionItem))
    })
    jsAry.push(conAry.join("||"))
  }
  return jsAry.join("")
}

/**
 * 获取条件节点的内容
 * @param jsAry
 * @param nodeItem
 */
export function getConditionNodeContent(jsAry, nodeItem, recordItem) {
  if (unref(nodeItem).conditionType === 'controlElseNode') {
    getElseNodeContent(jsAry, nodeItem,recordItem);
  } else {
    const {conditions, children} = nodeItem;
    const content=`if(${getConditionAryStr(conditions)}){
      ${getExeStr(children,recordItem)}
    } \n`
    jsAry.push(content);
  }
}

/**
 * 打开部件设计界面
 * @param props
 * @param state
 * @param stateRemarks
 */
export const openDesPage=function ({props,state,stateRemarks}){
  const params: any = {};
  params.setTotalLoginDes = true;//设置门户的标识
  params["sessionId"] = StorageUtils.getSessionItem("sessionId");
  params["projectI18n"] = StorageUtils.getItem('projectI18n');
  params["pageCode"] = unref(props).pageCode;
  params["openType"] = 'newWindow';
  params["pageName"] = (unref(props).winTitle||'')+"部件";
  params["moduleCode"] = unref(props).moduleCode;
  params["pageType"] = "subPageDes";

  //将本界面的全局变量和描述传递给子界面
  const stateJson=JSON.stringify(unref(state));
  const stateRemarksStr=JSON.stringify(unref(stateRemarks));
  StorageUtils.addSessionItem("stateJson",stateJson);
  StorageUtils.addSessionItem("stateRemarksStr",stateRemarksStr);
  nextTick(()=>{
    const vueDesUrl = getUrlParams("vueDesUrl", true);
    window.open(openUrl(`${vueDesUrl}#/commonPageDes`, params));
  })
}
